import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Outcomes } from './components/Outcomes';
import { ContentAccordion } from './components/ContentAccordion';
import { PilatesComparison } from './components/PilatesComparison';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { FaqSection } from './components/FaqSection';
import { trackMetaPageView } from './utils/metaPixel';
const CHECKOUT_URL = 'https://checkout.ebookbtnlines.shop/cart/45648604299311:1';
export function App() {
  useEffect(() => {
    trackMetaPageView();
  }, []);
  const goToCheckout = () => {
    window.location.assign(CHECKOUT_URL);
  };
  return <main className="w-full min-h-full bg-beige" data-id="element-0" data-mp="28tw4wqgqei2x">
      <Hero onCta={goToCheckout} data-id="element-1" data-mp="28sl5f2ubjwhm" />
      <PainPoints data-id="element-2" data-mp="23vkvuhy9gblr" />
      <Outcomes data-id="element-3" data-mp="23w4g45bdvc2y" />
      <ContentAccordion data-id="element-4" data-mp="23ujk0b9f7l2z" />
      <PilatesComparison data-id="element-5" data-mp="23v2u55stx56g" />
      <Testimonials data-id="element-6" data-mp="3ijxoypkvdyjd" />
      <Bonuses data-id="element-7" data-mp="3ikr002qv3a7b" />
      <Offer onCta={goToCheckout} data-id="element-8" data-mp="3iiwaeb4natww" />
      <FaqSection data-id="element-9" data-mp="3ihv0i9zd8dgr" />
      <footer className="w-full bg-beige py-8 text-center" data-id="element-10" data-mp="3mlj98vzqhf3l">
        <p className="text-xs text-brown-dark/50" data-id="element-11" data-mp="3mjzpuwis6nxl">
          © {new Date().getFullYear()} Pilates Resuelto · Todos los derechos
          reservados
        </p>
      </footer>
    </main>;
}